import type { SmriqJourneyError } from '../hooks/useSmriqJourney';

const SESSION_EXPIRED_CODES = new Set([
    'service_plan_session_expired',
    'service_plan_session_required',
]);

// Nothing about the plan can be changed once the session is gone, so every control
// that would feed the next `generate` reads this, not just the plan fields.
export const isSmriqSessionExpired = (error: SmriqJourneyError | null | undefined): boolean =>
    !!error && SESSION_EXPIRED_CODES.has(error.code);
